import React from "react";
import propTypes from "prop-types";
import { KeyAuditItem, KeyAuditItemStatus } from "../../../../logic/api";
import styles from "./styles";

import {
    FiChevronRight,
    FiHome,
} from 'react-icons/fi';

import flex from "../../../../styles/flex";
import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";


import { IoMdCar } from "react-icons/io";
import usePaths from "../../../../utility/paths";
import { useTranslation } from "react-i18next";


const KeyAuditViewListItem: React.FunctionComponent<{
    item: KeyAuditItem,
}> = (props) => {
    const paths = usePaths();
    const { t } = useTranslation();

    let title = t("lists.found");
    let border = styles.borderExpected;

    if (props.item.status == KeyAuditItemStatus.unexpected) {
        border = styles.borderUnexpected;
        title = t("lists.unexpected");
    } else if (props.item.status == KeyAuditItemStatus.missing) {
        border = styles.borderMissing;
        title = t("lists.missing");
    }

    return <div style={{ ...styles.listItem, ...border }} onClick={() => {
        window.open(paths.booking(props.item.booking.id));
    }}>
        <div style={{ position: "absolute", textAlign: "center", width: 120, left: -67, bottom: 0, height: 15, top: 30, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", color: "white", transform: "rotate(270deg)" }}>
            <span>{title}</span>
        </div>

        <div style={styles.listItemFlex}>
            {(props.item.status == KeyAuditItemStatus.expected && props.item.row != null) && (
                <div style={{
                    textAlign: "center",
                    width: 30,
                    height: 24,
                    borderRadius: 28,
                    fontSize: 15,
                    paddingTop: 2,
                    backgroundColor: "#EEE",
                    color: "#000",
                    fontWeight: "bold",
                    border: "solid 2px #DDD",
                    display: "inline-block",
                    verticalAlign: "middle",
                }}>
                    {props.item.row ?? ""}
                </div>
            )}
            <ListViewItemCard
                icon={<IoMdCar style={styles.icon} />}
                text={props.item.booking.vehicle.registration}
                subText={`${props.item.booking.vehicle.colour}, ${props.item.booking.vehicle.make}, ${props.item.booking.vehicle.model}`}
            />

            {(props.item.status == KeyAuditItemStatus.unexpected && props.item.expectedLocation != null) && (
                <ListViewItemCard
                    icon={<FiHome style={styles.icon} />}
                    text={t("lists.expectedLocation")}
                    subText={`${props.item.expectedLocation.parentName} / ${props.item.expectedLocation.name}`}
                />
            )}
            {(props.item.status == KeyAuditItemStatus.unexpected && props.item.expectedLocation == null) && (
                <ListViewItemCard
                    icon={<FiHome style={styles.icon} />}
                    text={t("lists.unexpected")}
                    subText={t("mobile.noLocation")}
                />
            )}




            <div style={flex.flexAuto}>
                <div style={{ ...flex.flexRows, alignItems: "center", height: "100%" }}>
                    <div style={flex.flexAuto}>
                        <FiChevronRight style={styles.iconChevron} />
                    </div>
                </div>
            </div>
        </div>
    </div>
}


KeyAuditViewListItem.propTypes = {
    item: propTypes.any.isRequired
};


export default KeyAuditViewListItem;